import { GET_SUBORDINATES } from "../../../../enums/Request/leader.requests.types";

export const getSubordinatesAction = (data) => {
    return {
        type: GET_SUBORDINATES,
        payload: data,
    };
};
